<template>
  <div class="right">
    <div class="field_left">
      <text-input id="businessmodelname"
                  :required="true"
                  v-model="entity.name"
                  ref="nameref"
                  :disabled="!$_updateActionAllowed"
      >
        <translate class="translate">Název</translate>
      </text-input>

    <textarea-input
        id="businessmodeldescription"
        rows=6
        cols=50
        v-model="entity.description"
        ref="descriptionref"
        :disabled="!$_updateActionAllowed"
    >
      <translate class="translate">Popis</translate>
    </textarea-input>
    </div>
    <div class="field_right">
      <text-input id="includeddevicecount"
                  ref="includeddevicecountref"
                  :required="true"
                  type="number"
                  v-model="entity.included_device_count"
                  :help-text="$gettext('Počet zařízení za které odběratel neplatí poplatek, pouze pro účely reportingu')"
                  :disabled="!$_updateActionAllowed"
      >
        <translate class="translate">Počet simultánně streamujících zařízení v ceně</translate>
      </text-input>
      <text-input id="includedfirstscreendevicecount"
                  ref="includedfirstscreendevicecountref"
                  :required="true"
                  type="number"
                  v-model="entity.included_firstscreen_device_count"
                  :help-text="$gettext('Počet firstscreen zařízení za které odběratel neplatí poplatek, pouze pro účely reportingu')"
                  :disabled="!$_updateActionAllowed"
      >
        <translate class="translate">Počet firstscreen zařízení v ceně</translate>
      </text-input>
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/common/TextInput"

import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"

export default {
  name: "SettingsForm",
  components: {TextInput},
  mixins: [formFilterData, requiredFields],
  props: {
    entity: Object,
  },
  methods: {
    validateBusinessModelFormRequiredFields() {
      let nameError = null

      if (!this.entity.name) {
        nameError = this.$gettext('Zadejte název')
      }

      if (nameError !== null) {
        this.setFieldInvalid('nameref', true, nameError)
      } else {
        this.setFieldInvalid('nameref')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/Forms/SettingsForm.vue